<script>
    import {getStyleValue} from "../../Common/tools"
    import ImageHeader from './ImageHeader.svelte';
    import Menu from "./Menu.svelte";

    export let data, meta, globalStyle;
</script>

<ImageHeader data={data} meta={meta} globalStyle={globalStyle}/>
<tr>
    <td class="spacer" style="font-size: 20px; line-height: 20px; height: 20px;" height="20">&nbsp;</td>
</tr>
<tr style="vertical-align: top;" valign="top">
    <th class="column column-st" width="{getStyleValue(globalStyle.width, 600)}">
        <center>
            <Menu data={data}/>
        </center>
    </th>
</tr>

